/* eslint max-len: ["error", 200] */

import 'isomorphic-fetch';
import './components/translations';
import './components/error_logger';
import './components/sentry';
import User from './components/user';
import AppInitializer from './components/app_initializer';
import './components/discovery';

import './components/adyen_ujs';
import ReverifyCreditCard from './components/bundled_checkout/reverify_credit_card';
import PollConfirmation from './components/bundled_checkout/poll_confirmation';
import PasswordOrGuestCheckoutSelection from './components/bundled_checkout/password_or_guest_checkout_selection';
import PasswordInput from './components/shared/password_input';
import AsyncLoader from './components/async_loader';
import CreditCardList from './components/credit_cards/credit_card_list';
import CategorySelect from './components/category_select';
import ImportsProgressBar from './components/dashboard/imports/progress_bar';
import EmailOfferForm from './components/dashboard/selling/email_offers/email_offer_form';
import BulkSalebutton from './components/dashboard/selling/listings_manager/sales/bulk_sale_button';
import OrderNotes from './components/dashboard/selling/order_notes/order_notes';
import ShopPaymentMethodSelectionContainer from './components/dashboard/selling/shop_policies/containers/payment_method_selection_container';
import ShopDirectCheckoutProfile from './components/dashboard/selling/shop_policies/direct_checkout_profile';
import AcceptedPaymentMethodsForm from './components/dashboard/selling/shop_policies/accepted_payment_methods_form';
import BumpBid from './components/dashboard/selling/bump_for_new/bump_bid';
import Reports from './components/dashboard/selling/reports/reports';
import ProductPageBump from './components/dashboard/selling/bump_for_new/product_page_bump';
import BumpModal from './components/dashboard/selling/bump_for_new/bump_modal';
import BumpDisplay from './components/dashboard/selling/bump_for_new/bump_display';
import EmailSignup from './components/email_signup/email_signup';
import Forms from './components/forms';
import GiftCardOptions from './components/gift_cards/gift_card_options';

import CanonicalProductMatcher from './components/listing_form/canonical_product_matcher';
import LocalizedContent from './components/listing_form/localized_content';
import ListingFormVideos from './components/listing_form/videos';
import ConditionExplanation from './components/listing_form/condition_explanation';
import TaxExemptCheckbox from './components/listing_form/tax_exempt_checkbox';
import MakeModel from './components/listing_form/make_model';
import ListingAttributes from './components/listing_form/listing_attributes';
import ListingAttributesContainer from './components/listing_form/listing_attributes_container';

import Loading from './components/shared/loading';
import ManualShippingInfoForm from './components/manual_shipping_info_form';
import TrackOrderForm from './components/track_order_form';
import OfferInput from './components/offers/offer_input';
import OfferModal from './components/offers/offer_modal';
import PageSearchBar from './components/shared/page_search_bar';
import PreviousOrders from './components/previous_orders';

import PriceGuideChart from './components/price_guide/transaction_history/chart';
import PriceGuideTable from './components/price_guide/transaction_history/table';
import ProductBundleForm from './components/product_bundles/product_bundle_form';
import ProductBundlePromo from './components/product_bundles/promo';
import ProductReviews from './components/product_reviews/product_reviews';
import ShippingProgressBar from './components/shared/shipping_progress_bar';
import ReferAFriendSocialButtons from './components/refer_a_friend_social_buttons';

import BankAccountFields from './components/shop/direct_checkout_profile/bank_account_fields';
import BankAccountForm from './components/bank_transfer_requests/bank_account_form';
import AmountFields from './components/bank_transfer_requests/amount_fields';

import ShareInput from './components/shared/share_input';
import Fotorama from './components/shared/fotorama';
import ShippingLabelAddressBox from './components/shipping_labels/address_box';
import ShopPaymentMethodSelector from './components/shop/payment_method_selector';
import ShopPaypalProfile from './components/shop/paypal_profile';
import ShopCurrencySelect from './components/shop/currency_select';
import StreetAddressInput from './components/bundled_checkout/street_address_input';
import Tooltip from './components/tooltip';
import UserBadges from './components/user_badges';
import DigitalListingDownloadButton from './components/digital_listings/standalone_download_button';

import Upsells from './components/product_show_page/upsells';
import SidebarUpsells from './components/product_show_page/sidebar_upsells';
import RelatedContent from './components/product_show_page/related_content';
import SimilarListings from './components/product_show_page/similar_listings';
import CartUpsells from './components/cart/cart_upsells';
import OtherBuyersWithListingInCart from './components/listings/other_buyers_with_listing_in_cart';

import StandaloneAjaxAddToCartButton from './components/listings/cart/standalone_ajax_add_to_cart_button';
import WatchButton from './components/listings/watch_button';

import Embeds from './components/conversations/embeds';
import CartBadge from './components/header/cart/cart_badge';
import MobileAppAds from './components/bundled_checkout/mobile_app_ads';

import ShippingRatesEditor from './components/shipping_rates_editor';

import ZopimActions from './components/zopim/zopim_actions';
import Zendesk from './components/zendesk';
import HelpDropdown from './components/header/help_dropdown';
import HeaderNavLinks from './components/header/header_nav_links';
import Events from './components/event_tracking';
import NavDropdownStore from './components/header/dropdown_store';

import RelatedArticles from './components/articles/related_articles';

import ReactUJS from './components/react_ujs';
import TrackInteraction from './components/shared/track_interaction';

// legacy components which can't be deferred
import { UI } from './components/legacy/ui';
import './components/legacy/init/hoverIntent';
import './components/legacy/readmore';
import './components/legacy/init/powertip';

// Some pages initialize this in script tags (e.g. /artist)
import './components/legacy/init/owl-carousel';
import YoutubeAPI from './components/legacy/youtube_api'; // /videos

import './components/castle';

AppInitializer.init();
TrackInteraction.init();

// Async load vintage JS
require.ensure(
  [],
  (require) => {
    require('./components/legacy');
  },
  'legacy',
);

window.User = User;

window.Reverb = Object.assign({}, window.Reverb, {
  AsyncLoader,
  BankAccountFields,
  CartBadge,
  CartUpsells,
  CategorySelect,
  CreditCardList,
  DigitalListingDownloadButton,
  EmailSignup,
  Events,
  Forms,
  Fotorama,
  HelpDropdown,
  Loading,
  ManualShippingInfoForm,
  TrackOrderForm,
  MobileAppAds,
  NavDropdownStore,
  HeaderNavLinks,
  OfferInput,
  OfferModal,
  OtherBuyersWithListingInCart,
  PageSearchBar,
  PreviousOrders,
  PriceGuideChart,
  PriceGuideTable,
  ProductBundleForm,
  ProductBundlePromo,
  ProductPageBump,
  BumpModal,
  BumpDisplay,
  ProductReviews,
  ShippingProgressBar,
  ReactUJS,
  ReferAFriendSocialButtons,
  ShareInput,
  ShippingLabelAddressBox,
  ShippingRatesEditor,
  ShopCurrencySelect,
  ShopPaymentMethodSelector,
  ShopPaypalProfile,
  StreetAddressInput,
  Tooltip,
  UI,
  UserBadges,
  YoutubeAPI,
  Zendesk,
  ZopimActions,
});

window.Reverb.Articles = { RelatedArticles };

window.Reverb.BankTransferRequests = {
  BankAccountForm,
  AmountFields,
};

window.Reverb.BundledCheckout = Object.assign({}, window.Reverb.BundledCheckout, {
  ReverifyCreditCard,
  PollConfirmation,
  PasswordOrGuestCheckoutSelection,
  PasswordInput,
});

window.Reverb.Conversations = window.Reverb.Conversations || {};
window.Reverb.Conversations.Embeds = Embeds;

window.Reverb.Dashboard = {
  AcceptedPaymentMethodsForm,
  BumpBid,
  Imports: {
    ProgressBar: ImportsProgressBar,
  },
  Reports,
  Selling: {
    EmailOffers: { EmailOfferForm },
    ListingsManager: { BulkSalebutton },
    OrderNotes,
  },
  ShopPaymentMethodSelectionContainer,
  ShopDirectCheckoutProfile,
};

window.Reverb.GiftCard = {
  GiftCardOptions,
};

window.Reverb.ListingForm = {
  CanonicalProductMatcher,
  LocalizedContent,
  Videos: ListingFormVideos,
  ConditionExplanation,
  TaxExemptCheckbox,
  MakeModel,
  ListingAttributes,
  ListingAttributesContainer,
};

window.Reverb.Listings = {
  StandaloneAjaxAddToCartButton,
  WatchButton,
  OtherBuyersWithListingInCart,
};

window.Reverb.ProductShowPage = {
  Upsells,
  SidebarUpsells,
  RelatedContent,
  SimilarListings,
};



// WEBPACK FOOTER //
// ./javascripts/components.js